import React, { useEffect, useState, useMemo, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate, useSearchParams, Link, useLocation } from 'react-router-dom';
import { addDays } from 'date-fns';
import { es } from 'date-fns/locale';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import './Opportunities.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import {
  Table,
  Form,
  Button,
  InputGroup,
} from 'react-bootstrap';
import { currencyFormatter, numberFormatter } from '../../../utils/services';
import { list_opportunities, insert_new_opportunity, send_newLogEntry } from '../../../utils/crm_services';
import New_opportunity from './modals/New_opportunity';
import Modal_proyectos from '../../menus/Modal';
import CountryPieChart from './charts/CountryPieChart';
import Select, { components } from 'react-select';
import PipelineAreaChart from './charts/PipelineAreaChart';
import ActiveWonStackedBar from './charts/ActiveWonStackedBar';
import * as rdr from 'react-date-range';
import CustomDateRange from './charts/CustomDateRange';

const FILTERS_URL_PARAM = 'f';

function decodeFiltersFromUrl(encoded) {
  if (!encoded || typeof encoded !== 'string') return null;
  try {
    const base64 = decodeURIComponent(encoded);
    const binary = atob(base64);
    const json = decodeURIComponent(escape(binary));
    return JSON.parse(json);
  } catch {
    return null;
  }
}

function encodeFiltersForUrl(payload) {
  try {
    const json = JSON.stringify(payload);
    const base64 = btoa(unescape(encodeURIComponent(json)));
    return encodeURIComponent(base64);
  } catch {
    return '';
  }
}

function Opportunities  ({user_id, permission, usr_type, channel_id = '', channel_name = '', channelCanManage = false}) {

    const token = localStorage.getItem("token");
    const hasFullChannelView = parseInt(usr_type, 10) === 0 || Boolean(channelCanManage);

    const [searchTerm, setSearchTerm] = useState('');
    const [totalMoneyAmount, setTotalMoneyAmount] = useState(0);
    
    const [totalT8lt, settotalT8lt] = useState(0);
    const [totalT8std, settotalT8std] = useState(0);
    const [totalT8256, settotalT8256] = useState(0);
    const [totalT8pro, settotalT8pro] = useState(0);
    const [totalT8proai, settotalT8proai] = useState(0);
    const [totalT8router, settotalT8router] = useState(0);
    const [totalSimple2, settotalSimple2] = useState(0);
    const [totalTeacherPro12, settotalTeacherPro12] = useState(0);
    const [totalStudentSuper12, settotalStudentSuper12] = useState(0);
    const [totalTeacherPremiumAi12, settotalTeacherPremiumAi12] = useState(0);
    const [totalObservatorioAnalytics, settotalObservatorioAnalytics] = useState(0);
    const [totalStemLabsOffline12, settotalStemLabsOffline12] = useState(0);

    const [roiByOwner, setroiByOwner] = useState(0);

    const [pipelineForecastChart, setPipelineForecastChart] = useState([]);

   
    const [recordCount, setrecordCount] = useState(false);

    const [selectedStages, setSelectedStages] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState([1]);
    const [selectedTypes, setSelectedTypes] = useState([]);
    const [selectedSalesMan, setselectedSalesMan] = useState([]);
    const [salesManOptions, setsalesManOptions] = useState([]);
    const [selectedCountries, setSelectedCountries] = useState([]);
    const [countryOptions, setCountryOptions] = useState([]);
    const [selectedChannelTiers, setSelectedChannelTiers] = useState([]);
    const [channelTierOptions, setChannelTierOptions] = useState([]);
    const [selectedTomiOwner, setSelectedTomiOwner] = useState([]);
    const [tomiOwnerOptions, setTomiOwnerOptions] = useState([]);
    const [typeOptions, setTypeOptions] = useState([]);
    const [isModalOpen, setModalOpen] = useState(false);
   
    const [sortConfig, setSortConfig] = useState({ key: 'stage', dir: 'desc' });
    const [initialRows, setInitialRows] = useState([]);

    const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
    const datePickerRef = React.useRef(null);
    const [datePickerPosition, setDatePickerPosition] = useState({});

    const [editingClosingDateId, setEditingClosingDateId] = useState(null);
    const [editingClosingDateValue, setEditingClosingDateValue] = useState('');

    



     const stageOptions = [
        { label: '20% - Viewed', value: 20 },
        { label: '40% - Quoated', value: 40 },
        { label: '60% - Accepted', value: 60 },
        { label: '80% - Waiting PO', value: 80 },
      ];


      const statusOptions = [
        { label: 'Pending', value: 0 },
         { label: 'Active', value: 1 },
        { label: 'Won', value: 2 },
        { label: 'Lost', value: 3 },
        { label: 'Anulated', value: 4 },
      ];

        

  const [range, setRange] = useState([
    {
        startDate: null,
        endDate: null,
        key: 'selection'
    }
]);

    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const location = useLocation();
    const isInitialMount = useRef(true);

    // Restaurar filtros desde la URL al montar (o al volver a la página)
    useEffect(() => {
      const encoded = searchParams.get(FILTERS_URL_PARAM);
      const saved = decodeFiltersFromUrl(encoded);
      if (saved && typeof saved === 'object') {
        if (typeof saved.searchTerm === 'string') setSearchTerm(saved.searchTerm);
        if (Array.isArray(saved.selectedStages)) setSelectedStages(saved.selectedStages.map((v) => Number(v)).filter((n) => !Number.isNaN(n)));
        if (Array.isArray(saved.selectedStatus)) setSelectedStatus(saved.selectedStatus.map((v) => Number(v)).filter((n) => !Number.isNaN(n)));
        if (Array.isArray(saved.selectedTypes)) setSelectedTypes(saved.selectedTypes.map((v) => Number(v)).filter((n) => !Number.isNaN(n)));
        if (Array.isArray(saved.selectedSalesMan)) setselectedSalesMan(saved.selectedSalesMan.map((v) => String(v)));
        if (Array.isArray(saved.selectedCountries)) setSelectedCountries(saved.selectedCountries.map((v) => String(v)));
        if (Array.isArray(saved.selectedChannelTiers)) setSelectedChannelTiers(saved.selectedChannelTiers.map((v) => String(v)));
        if (Array.isArray(saved.selectedTomiOwner)) setSelectedTomiOwner(saved.selectedTomiOwner.map((v) => String(v)));
        if (saved.range && typeof saved.range === 'object' && (saved.range.startDate != null || saved.range.endDate != null)) {
          const start = saved.range.startDate ? new Date(saved.range.startDate) : null;
          const end = saved.range.endDate ? new Date(saved.range.endDate) : null;
          if ((!start || !Number.isNaN(start.getTime())) && (!end || !Number.isNaN(end.getTime()))) {
            setRange([{ startDate: start, endDate: end, key: 'selection' }]);
          }
        }
        const validSortKeys = ['stage', 'moneyAmount', 'running_days', 'closing_date', 'last_activity'];
        if (saved.sortConfig && typeof saved.sortConfig === 'object' && validSortKeys.includes(saved.sortConfig.key) && (saved.sortConfig.dir === 'asc' || saved.sortConfig.dir === 'desc')) {
          setSortConfig({ key: saved.sortConfig.key, dir: saved.sortConfig.dir });
        }
      }
      isInitialMount.current = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps -- solo leer URL al montar
    }, []);

    // Escribir filtros en la URL cuando cambien (solo en /opportunities para no pisar ?id en /opportunitypage)
    useEffect(() => {
      if (isInitialMount.current) return;
      if (location.pathname !== '/opportunities') return;
      const r0 = range[0];
      const startDate = r0?.startDate && !Number.isNaN(r0.startDate.getTime()) ? r0.startDate.toISOString() : null;
      const endDate = r0?.endDate && !Number.isNaN(r0.endDate.getTime()) ? r0.endDate.toISOString() : null;
      const payload = {
        searchTerm,
        selectedStages,
        selectedStatus,
        selectedTypes,
        selectedSalesMan,
        selectedCountries,
        selectedChannelTiers,
        selectedTomiOwner,
        range: { startDate, endDate },
        sortConfig: { key: sortConfig.key, dir: sortConfig.dir }
      };
      const defaultPayload = {
        searchTerm: '',
        selectedStages: [],
        selectedStatus: [1],
        selectedTypes: [],
        selectedSalesMan: [],
        selectedCountries: [],
        selectedChannelTiers: [],
        selectedTomiOwner: [],
        range: { startDate: null, endDate: null },
        sortConfig: { key: 'stage', dir: 'desc' }
      };
      const hasFilters = searchTerm !== defaultPayload.searchTerm
        || JSON.stringify(selectedStages) !== '[]'
        || JSON.stringify(selectedStatus) !== '[1]'
        || JSON.stringify(selectedTypes) !== '[]'
        || selectedSalesMan.length > 0
        || selectedCountries.length > 0
        || selectedChannelTiers.length > 0
        || selectedTomiOwner.length > 0
        || startDate != null
        || endDate != null
        || sortConfig.key !== 'stage'
        || sortConfig.dir !== 'desc';
      const next = new URLSearchParams();
      if (hasFilters) next.set(FILTERS_URL_PARAM, encodeFiltersForUrl(payload));
      setSearchParams(next, { replace: true });
    }, [location.pathname, searchTerm, selectedStages, selectedStatus, selectedTypes, selectedSalesMan, selectedCountries, selectedChannelTiers, selectedTomiOwner, range, sortConfig, setSearchParams]);   
    
    // --- Filtrado + ordenamiento memoizados ---
    const rows = useMemo(() => {
      let result = initialRows;
  
      const term = searchTerm.toLowerCase();
        result = result.filter((r) => {
          // Comprueba si 'opportunitieName' existe y contiene el término de búsqueda
          const nameMatch = r.opportunitieName && String(r.opportunitieName).toLowerCase().includes(term);
          // Comprueba si 'channelname' existe y contiene el término de búsqueda
          const channelMatch = r.channelname && String(r.channelname).toLowerCase().includes(term);
          const countryMatch = r.country && String(r.country).toLowerCase().includes(term);

          // Retorna true si el término se encuentra en cualquiera de las dos columnas
          return nameMatch || channelMatch || countryMatch;
        });

          if (selectedStages.length > 0) {
            // Check if 'all' is explicitly selected, or if there's no 'all' option and
            // selectedStages is not empty.
            const allStagesSelected = selectedStages.includes('all');

            if (!allStagesSelected) {
              result = result.filter((r) => {
                // Convert the stage from the item (e.g., "10%") to a number (e.g., 10)
                const itemStageValue = parseInt(r.stage.replace('%', ''), 10);
                // Check if the item's stage value is included in the array of selected stages
                return selectedStages.includes(itemStageValue);
              });
            }
            // If 'allStagesSelected' is true, or if selectedStages is empty,
            // we don't apply a filter for stages, so all results remain.
          }

          if (selectedStatus.length > 0) {
           
       
              result = result.filter((r) => {
         
              
                const itemStageValue = parseInt(r.current_status);
                // Check if the item's stage value is included in the array of selected stages
                return selectedStatus.includes(itemStageValue);
              });
          
          
          }

          if (selectedTypes.length > 0) {
            result = result.filter((r) => {
              if (r.type === null || r.type === undefined) {
                return false;
              }
              const rowType = Number(r.type);
              if (Number.isNaN(rowType)) {
                return false;
              }
              return selectedTypes.includes(rowType);
            });
          }
          
  
          if (selectedSalesMan.length > 0) {
            // Check if 'all' is explicitly selected, or if there's no 'all' option and
            // selectedStages is not empty.
            const allSalesmanSelected = selectedSalesMan.includes('all');

            if (!allSalesmanSelected) {
              result = result.filter((r) => {
                // Check if the item's stage value is included in the array of selected stages
                return selectedSalesMan.includes(r.owner_usr);
              });
            }
            // If 'allStagesSelected' is true, or if selectedStages is empty,
            // we don't apply a filter for stages, so all results remain.
          }

          if (selectedCountries.length > 0) {
            result = result.filter((r) => {
              if (!r.country) {
                return false;
              }
              return selectedCountries.includes(r.country);
            });
          }

          if (selectedTomiOwner.length > 0) {
            const allTomiOwnerSelected = selectedTomiOwner.includes('all');

            if (!allTomiOwnerSelected) {
              result = result.filter((r) => selectedTomiOwner.includes(r.internal_owner_name));
            }
          }

          if (selectedChannelTiers.length > 0) {
            result = result.filter((r) => {
              if (!r.channel_tier) {
                return false;
              }
              return selectedChannelTiers.includes(r.channel_tier);
            });
          }

          if (range[0] && range[0].startDate && range[0].endDate) {
    // Para evitar errores por la hora, ajustamos las fechas del rango:
    // La fecha de inicio la consideramos desde el principio del día (00:00:00).
    const startDate = new Date(range[0].startDate);
    startDate.setHours(0, 0, 0, 0);

    // La fecha de fin la consideramos hasta el último milisegundo del día (23:59:59).
    // Esto asegura que se incluyan todos los eventos del día final.
    const endDate = new Date(range[0].endDate);
    endDate.setHours(23, 59, 59, 999);

    result = result.filter((r) => {
        // Primero, nos aseguramos de que la fila tenga una fecha de cierre válida.
        if (!r.closing_date) {
            return false;
        }

        const closingDate = new Date(r.closing_date);

        // Hacemos una comprobación para evitar errores si la fecha es inválida.
        if (isNaN(closingDate.getTime())) {
            return false; 
        }

        // La condición final: la fecha de cierre debe estar DENTRO del rango.
        return closingDate >= startDate && closingDate <= endDate;
          });
      }

       // --- Calcular los totales después del filtrado ---
        let temptotalMoneyAmount = 0;
        let temptotalT8lt = 0;
        let temptotalT8std = 0;
        let temptotalT8256 = 0;
        let temptotalT8pro = 0;
        let temptotalT8proai = 0;
        let temptotalT8router = 0;
        let temptotalSimple2 = 0;
        let temptotalTeacherPro12 = 0;
        let temptotalStudentSuper12 = 0;
        let temptotalTeacherPremiumAi12 = 0;
        let temptotalObservatorioAnalytics = 0;
        let temptotalStemLabsOffline12 = 0;

       

        result.forEach((row) => {
          const status = parseInt(row.current_status, 10);
          // Total solo Active (1) y Won (2)
          if (status === 1 || status === 2) {
            temptotalMoneyAmount += parseFloat(row.moneyAmount) || 0;
          }

          temptotalT8lt += parseInt(row.tomi8_lt);
          temptotalT8std += parseInt(row.tomi8_std);
          temptotalT8256 += parseInt(row.tomi8_256);
          temptotalT8pro += parseInt(row.tomi8_pro);
          temptotalT8proai += parseInt(row.tomi8_pro_ai);
          temptotalT8router += parseInt(row.tomi8_router);
          temptotalSimple2 += parseInt(row.simple2);
          temptotalTeacherPro12 += parseInt(row.teacher_pro_12);
          temptotalStudentSuper12 += parseInt(row.student_super_12);
          temptotalTeacherPremiumAi12 += parseInt(row.teacher_premium_ai_12);
          temptotalObservatorioAnalytics += parseInt(row.observatorio_analytics);
          temptotalStemLabsOffline12 += parseInt(row.stem_labs_offline_12);
        });

       
        setTotalMoneyAmount(temptotalMoneyAmount);
        settotalT8lt(temptotalT8lt);
        settotalT8std(temptotalT8std);
        settotalT8256(temptotalT8256);
        settotalT8pro(temptotalT8pro);
        settotalT8proai(temptotalT8proai);
        settotalT8router(temptotalT8router);
        settotalSimple2(temptotalSimple2);
        settotalTeacherPro12(temptotalTeacherPro12);
        settotalStudentSuper12(temptotalStudentSuper12);
        settotalTeacherPremiumAi12(temptotalTeacherPremiumAi12);
        settotalObservatorioAnalytics(temptotalObservatorioAnalytics);
        settotalStemLabsOffline12(temptotalStemLabsOffline12);

      result = [...result].sort((a, b) => {
        let aVal = a[sortConfig.key];
        let bVal = b[sortConfig.key];

      
        
        if (sortConfig.key === 'moneyAmount' || sortConfig.key === 'running_days' || sortConfig.key === 'last_activity'){
            aVal = parseFloat(aVal);
            bVal = parseFloat(bVal);
            if (Number.isNaN(aVal)) aVal = Infinity;
            if (Number.isNaN(bVal)) bVal = Infinity;
        }else if (sortConfig.key === 'closing_date'){
             aVal = aVal ? new Date(aVal) : new Date(0);
             bVal = bVal ? new Date(bVal) : new Date(0);
        }

        
        
  
        if (aVal === bVal) return 0;
        const order = aVal > bVal ? 1 : -1;
        return sortConfig.dir === 'asc' ? order : -order;
      });



    if (result) {
        if (result.length>0) {
          const summarizedOpp = summarizeByClosingMonth(result);
          setPipelineForecastChart(summarizedOpp);
        }
      }

  setrecordCount(result.length);
      return result;
    }, [searchTerm, sortConfig, initialRows, selectedStages, selectedStatus, selectedTypes, selectedSalesMan, selectedCountries, selectedChannelTiers, selectedTomiOwner, range]);
  
    // --- Handlers ---
    const toggleSort = (key) => {
      setSortConfig((prev) => {
        if (prev.key === key) {
          return { key, dir: prev.dir === 'asc' ? 'desc' : 'asc' };
        }
        return { key, dir: 'asc' };
      });
    };

    const startEditClosingDate = (e, row) => {
      e.stopPropagation();
      const val = row.closing_date;
      const forInput = !val || val === '0000-00-00' || val === '' ? '' : (val.length >= 10 ? val.substring(0, 10) : val);
      setEditingClosingDateId(row.id);
      setEditingClosingDateValue(forInput);
    };

    const saveClosingDate = async (row, newClosingDateStr) => {
      const closingDateFormatted = (!newClosingDateStr || newClosingDateStr === '0000-00-00') ? '' : (new Date(newClosingDateStr)).toISOString().split('T')[0];
      const result = await insert_new_opportunity(
        token,
        row.opportunitieName,
        row.channel_id,
        row.description ?? '',
        row.protectedUntil ?? '',
        closingDateFormatted,
        row.country ?? '',
        row.type ?? 0,
        row.stageNum ?? parseInt(String(row.stage).replace('%', ''), 10),
        row.current_status,
        row.id
      );
      if (result === 'INVALID') {
        navigate('/');
        return;
      }
      if (result === 'UPDATED') {
        const oldClosing = (row.closing_date || '').toString().substring(0, 10);
        if (oldClosing !== '' && oldClosing !== closingDateFormatted) {
          await send_newLogEntry(token, row.id, 'Old closing date ' + row.closing_date, 1);
        }
        fetchlistOpportunities();
      }
      setEditingClosingDateId(null);
      setEditingClosingDateValue('');
    };

    const cancelEditClosingDate = () => {
      setEditingClosingDateId(null);
      setEditingClosingDateValue('');
    };

  
  
    // Icono flecha ↑↓
    const SortIcon = ({ col }) =>
      sortConfig.key === col ? (sortConfig.dir === 'asc' ? '↑' : '↓') : '↕';


     useEffect(() => {
        fetchlistOpportunities();
      }, [token]); 

      useEffect(() => {
        const handleClickOutside = (event) => {
          if (datePickerRef.current && !datePickerRef.current.contains(event.target)) {
            setIsDatePickerOpen(false);
          }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, [datePickerRef]);
      

    async function fetchlistOpportunities() {
            const opportunityList = await list_opportunities(token, channel_id);
            if (opportunityList==="INVALID"){
                navigate("/");
            }else{
             
               const tempList= opportunityList["opp_data"].map((celement, index) => {
          
                return {
                  id: celement.id,
                  opportunitieName: celement.name,
                  channel_id: celement.channel_id,
                  description: celement.description ?? '',
                  protectedUntil: celement.protectedUntil ?? '',
                  closing_date: celement.closing_date,
                  created_at: celement.created_at,
                  country: celement.country,
                  current_status: celement.current_status,
                  created_by: celement.created_by,
                  owner_usr:celement.owner_name,
                  internal_owner_id: celement.internal_owner,
                  internal_owner_name: celement.internal_owner_name,
                  channelname: celement.channel_name,
                  profit: parseInt(celement.profit),
                  moneyAmount: parseInt(celement.dollar_amount),
                  stage: `${celement.stage}%`,
                  stageNum: celement.stage,
                  tomi8_lt:celement.tomi8_lt,
                  tomi8_std:celement.tomi8_std,
                  tomi8_256:celement.tomi8_256,
                  tomi8_pro:celement.tomi8_pro,
                  tomi8_pro_ai:celement.tomi8_pro_ai,
                  tomi8_router:celement.tomi8_router,
                  simple2:celement.simple2,
                  teacher_pro_12: celement.teacher_pro_12,
                  student_super_12: celement.student_super_12,
                  teacher_premium_ai_12: celement.teacher_premium_ai_12,
                  observatorio_analytics: celement.observatorio_analytics,
                  stem_labs_offline_12: celement.stem_labs_offline_12,
                  last_activity: celement.last_activity,
                  channel_tier: celement.channel_tier != null ? String(celement.channel_tier) : null,
                  type: celement.type !== null && celement.type !== undefined && celement.type !== ''
                    ? Number(celement.type)
                    : null,
                  index:index
                };
              });


              // Agrupar y sumar los costos e ingresos con la nueva condición
              const totalsByOwner = tempList.reduce((acc, opportunity) => {
                const owner = opportunity.owner_usr;

                // Si el propietario no existe en el acumulador, lo inicializamos
                if (!acc[owner]) {
                  acc[owner] = {
                    owner_usr: owner,
                    totalCardCost: 0,
                    totalProfitAmount: 0,
                  };
                }

                // ⭐️ Sumamos el moneyAmount SÓLO si el stage es '100%'
                if (opportunity.stage === '100%') {
                  acc[owner].totalProfitAmount += opportunity.profit;
                }

                return acc;
              }, {});

              // El resto del código para calcular el ROI sigue igual
              const roiByOwner = Object.values(totalsByOwner).map(ownerData => {
                const { totalProfitAmount, totalCardCost } = ownerData;
                
                const roi = totalCardCost > 0 
                  ? ((totalProfitAmount - totalCardCost) / totalCardCost) * 100 
                  : 0;

                return {
                  ...ownerData,
                  roi: roi
                };
              });

              const roiDataFiltrado = roiByOwner.filter(vendedor => 
                vendedor && 
                vendedor.roi !== 0
              );
              setroiByOwner(roiDataFiltrado);


            // Paso 1: Mapear la lista para obtener solo los valores de 'owner_usr'
          const allOwnerUserNames = tempList.map(item => item.owner_usr);

          // Paso 2: Usar un Set para obtener solo los valores únicos
          const uniqueOwnerUserNamesSet = new Set(allOwnerUserNames);

          // Paso 3: Convertir el Set de nuevo a un Array (opcional, pero a menudo útil)
          const uniqueOwnerUserNames = Array.from(uniqueOwnerUserNamesSet);

          const uniqueOwnerUserOptions = uniqueOwnerUserNames.map(name => ({
            value: name,
            label: name
          }));
              setsalesManOptions(uniqueOwnerUserOptions);

          const countryValues = tempList
            .map(item => item.country)
            .filter((country) => !!country && country.trim() !== '');
          const uniqueCountryValues = Array.from(new Set(countryValues));
          const uniqueCountryOptions = uniqueCountryValues.map(country => ({
            value: country,
            label: country
          }));
          setCountryOptions(uniqueCountryOptions);
          setSelectedCountries((prevSelected) =>
            prevSelected.filter((country) => uniqueCountryValues.includes(country))
          );

          const allTomiOwnerNames = tempList
            .map(item => item.internal_owner_name)
            .filter((name) => !!name);
          const uniqueTomiOwnerNames = Array.from(new Set(allTomiOwnerNames));
          const uniqueTomiOwnerOptions = uniqueTomiOwnerNames.map(name => ({
            value: name,
            label: name
          }));
          setTomiOwnerOptions(uniqueTomiOwnerOptions);

          const channelTierValues = tempList
            .map(item => item.channel_tier)
            .filter((tier) => tier !== null && tier !== undefined && tier !== '');
          const uniqueChannelTierValues = Array.from(new Set(channelTierValues));
          const uniqueChannelTierOptions = uniqueChannelTierValues.map(tier => ({
            value: tier,
            label: tier
          }));
          setChannelTierOptions(uniqueChannelTierOptions);
          setSelectedChannelTiers((prevSelected) =>
            prevSelected.filter((tier) => uniqueChannelTierValues.includes(tier))
          );

          const typeValues = tempList
            .map(item => item.type)
            .filter((type) => type !== null && type !== undefined && !Number.isNaN(type));
          const uniqueTypeValues = Array.from(new Set(typeValues));
          const typeLabelMap = {
            0: 'Gobierno',
            1: 'Consumo',
            3: 'Online',
          };
          const uniqueTypeOptions = uniqueTypeValues
            .map((type) => ({
              value: type,
              label: typeLabelMap[type] || `Tipo ${type}`,
            }))
            .sort((a, b) => a.value - b.value);
          setTypeOptions(uniqueTypeOptions);
          setSelectedTypes((prevSelected) =>
            prevSelected.filter((type) => uniqueTypeValues.includes(type))
          );
        
              setInitialRows(tempList);
              
            }
          }

          function summarizeByClosingMonth(tempList) {
    const summarizedByMonth = {};

    tempList.forEach(opportunity => {
        const owner = opportunity.owner_usr;
        const closingMonth = opportunity.closing_date?.split(" ")[0]?.substring(0, 7); // "YYYY-MM"
        const amount = Number(opportunity.moneyAmount || 0);

        if (!closingMonth) return;

        if (!summarizedByMonth[owner]) {
            summarizedByMonth[owner] = {};
        }

        if (!summarizedByMonth[owner][closingMonth]) {
            summarizedByMonth[owner][closingMonth] = 0;
        }

        summarizedByMonth[owner][closingMonth] += amount;
    });

    // Convertir a formato final: [{ owner_usr, values: [ { "2025-06": total }, ... ] }]
    const result = Object.entries(summarizedByMonth).map(([owner, monthTotals]) => {
        const sortedMonthKeys = Object.keys(monthTotals).sort(); // Orden de menor a mayor
        const values = sortedMonthKeys.map(month => ({ [month]: monthTotals[month] }));

        return {
            owner_usr: owner,
            values: values
        };
    });

    return result;
}


    // Chart Active/Won/Lost: solo filtro de fechas (closing_date en rango)
    const { activeAmount, wonAmount, lostAmount } = useMemo(() => {
      let active = 0;
      let won = 0;
      let lost = 0;
      let list = initialRows;
      if (range[0] && range[0].startDate && range[0].endDate) {
        const startDate = new Date(range[0].startDate);
        startDate.setHours(0, 0, 0, 0);
        const endDate = new Date(range[0].endDate);
        endDate.setHours(23, 59, 59, 999);
        list = initialRows.filter((r) => {
          if (!r.closing_date) return false;
          const closingDate = new Date(r.closing_date);
          return !isNaN(closingDate.getTime()) && closingDate >= startDate && closingDate <= endDate;
        });
      }
      list.forEach((r) => {
        const amount = Number(r.moneyAmount) || 0;
        const status = parseInt(r.current_status, 10);
        if (status === 1) active += amount;
        else if (status === 2) won += amount;
        else if (status === 3) lost += amount;
      });
      return { activeAmount: active, wonAmount: won, lostAmount: lost };
    }, [initialRows, range]);

    const { chartLabels, chartDataValues } = useMemo(() => {
                         // 1. Contar las ocurrencias de cada país
              // AHORA: Sumando el moneyAmount
                    const countryTotals = rows.reduce((acc, current) => {
                      if (current.status != 4){
                      const country = current.country ;
                      // En lugar de sumar 1, sumamos el `moneyAmount` del elemento actual.
                      // Usamos Number() para asegurar que el valor sea numérico.
                      const amount = Number(current.moneyAmount) || 0;
                      acc[country] = (acc[country] || 0) + amount; // <-- La línea clave del cambio
                      
                      return acc;
                      }
                    }, {});

                // countryCounts se verá así: { "Colombia": 15, "México": 10, "USA": 8 }

        return {
            chartLabels: Object.keys(countryTotals),
            chartDataValues: Object.values(countryTotals)
        };
    }, [rows]);

          function getDaysDifferenceIgnoringTime(createdAtDateString) {
            // 1. Convertir la cadena de fecha a un objeto Date
            const createdDate = new Date(createdAtDateString);
          
            // 2. Obtener la fecha actual
            const today = new Date();
          
            // 3. Establecer ambas fechas a la medianoche (00:00:00.000)
            // Esto elimina cualquier efecto de la hora y garantiza que solo se comparen los días.
            createdDate.setHours(0, 0, 0, 0);
            today.setHours(0, 0, 0, 0);
          
            // 4. Calcular la diferencia en milisegundos
            const differenceInMilliseconds = today.getTime() - createdDate.getTime();
          
            // 5. Convertir la diferencia de milisegundos a días
            const millisecondsPerDay = 1000 * 60 * 60 * 24;
            const differenceInDays = differenceInMilliseconds / millisecondsPerDay;
          
            // 6. Redondear al número entero de días
            // Math.floor() es ideal para obtener solo los días completos transcurridos.
            return Math.floor(differenceInDays);
          }

  const getStageByValue = (values) => {
    if (!Array.isArray(values)) {
      return []; // Ensure it's always an array for multi-select
    }
    return stageOptions.filter(option => values.includes(option.value));
  };

   const getStatusByValue = (values) => {
    if (!Array.isArray(values)) {
      return []; // Ensure it's always an array for multi-select
    }
    return statusOptions.filter(option => values.includes(option.value));
  };

  const getTypeByValue = (values) => {
    if (!Array.isArray(values)) {
      return [];
    }
    return typeOptions.filter(option => values.includes(option.value));
  };

    const getsalesManByValue = (values) => {
    if (!Array.isArray(values)) {
      return []; // Ensure it's always an array for multi-select
    }
    return salesManOptions.filter(option => values.includes(option.value));
  };

  const getChannelTierByValue = (values) => {
    if (!Array.isArray(values)) {
      return [];
    }
    return channelTierOptions.filter(option => values.includes(option.value));
  };

  const getTomiOwnerByValue = (values) => {
    if (!Array.isArray(values)) {
      return [];
    }
    return tomiOwnerOptions.filter(option => values.includes(option.value));
  };

  const getCountryByValue = (values) => {
    if (!Array.isArray(values)) {
      return [];
    }
    return countryOptions.filter(option => values.includes(option.value));
  };


 const CustomMultiValueLabel = (props) => {
  const { data, innerProps, selectProps } = props;
  const originalLabel = data.label;
  const maxLength = 4; // Define el número máximo de caracteres que quieres mostrar

  // Aplica el truncamiento si la etiqueta es más larga que maxLength
  const truncatedLabel = originalLabel.length > maxLength
    ? originalLabel.substring(0, maxLength) + '.'
    : originalLabel;

  return (
    <components.MultiValueLabel {...props}>
      {truncatedLabel}
    </components.MultiValueLabel>
  );
};


const handleDateChange = (item) => {
    const newRange = [item.selection];
    setRange(newRange);

    // Comprobamos si la fecha de inicio y fin son diferentes.
    // Esto es verdadero solo después de que el usuario hace el segundo clic.
    if (newRange[0].startDate && newRange[0].endDate && newRange[0].startDate.getTime() !== newRange[0].endDate.getTime()) {
        // ¡Cierra el calendario!
        setIsDatePickerOpen(false);
    }
};
const handleDatePickerOpen = () => {
    if (datePickerRef.current) {
        const inputRect = datePickerRef.current.getBoundingClientRect();
        const screenWidth = window.innerWidth;
        const calendarWidth = 650; // Ancho aproximado del calendario de 2 meses

        // Si el calendario se sale de la pantalla por la derecha...
        if (inputRect.left + calendarWidth > screenWidth) {
            // ...lo alineamos a la derecha del contenedor.
            setDatePickerPosition({ right: 0, left: 'auto' });
        } else {
            // ...si no, lo alineamos a la izquierda como siempre.
            setDatePickerPosition({ left: 0, right: 'auto' });
        }
    }
    setIsDatePickerOpen(true);
};

const clearDateFilter = (event) => {
    // Detiene la propagación para evitar que también se abra el calendario
    event.stopPropagation(); 
    
    setRange([
        {
            startDate: null,
            endDate: null,
            key: 'selection'
        }
    ]);
};
          
    // ---------- UI ----------
    return (
      <div className="container-fluid py-2 opportunities-page">


          <Modal_proyectos isOpen={isModalOpen} onClose={() => setModalOpen(false)}
              title='New Opportunity'
              contentClassName="modal-content2--new-opportunity"
          >  
               <New_opportunity token={token} channel_name={channel_name} channel_id={channel_id} onSet={() => setModalOpen(false)}></New_opportunity>

          </Modal_proyectos>
      <div className="d-flex justify-content-between align-items-center mb-2">
      
      {hasFullChannelView && (
         <>
  {/* Tres columnas: totales | Forecast by Month (centro) | gráfico torta */}
  <div className="container-fluid row g-2 align-items-stretch">
    
    {/* --- COLUMNA IZQUIERDA: Total + totales (Pro-Ai, Simple2 arriba; LT, STD, PRO abajo) --- */}
    <div className="col-lg-3 d-flex flex-column gap-2">
      <div className="card shadow-sm opportunities-compact-card">
        <div className="card-body py-1 px-2">
          <div className="text-center">
            <p className="small text-muted mb-0" style={{ fontSize: '0.7rem' }}>Total</p>
            <h6 className="fw-bold text-dark mb-0">{currencyFormatter.format(totalMoneyAmount)}</h6>
          </div>
        </div>
      </div>
      <div className="card shadow-sm opportunities-compact-card flex-grow-1">
        <div className="card-body py-1 px-2">
          <div className="d-flex flex-column gap-2">
            <div className="d-flex flex-wrap gap-2 justify-content-between">
              <div className="p-1 border rounded bg-light text-center flex-grow-1">
                <p className="small text-muted mb-0" style={{ fontSize: '0.7rem' }}>PRO-Ai</p>
                <h6 className="fw-bold mb-0" style={{ fontSize: '0.85rem' }}>{numberFormatter.format(totalT8proai)}</h6>
              </div>
              <div className="p-1 border rounded bg-light text-center flex-grow-1">
                <p className="small text-muted mb-0" style={{ fontSize: '0.7rem' }}>Simple2</p>
                <h6 className="fw-bold mb-0" style={{ fontSize: '0.85rem' }}>{numberFormatter.format(totalSimple2)}</h6>
              </div>
            </div>
            <div className="d-flex flex-wrap gap-2 justify-content-between">
              <div className="p-1 border rounded bg-light text-center flex-grow-1">
                <p className="small text-muted mb-0" style={{ fontSize: '0.7rem' }}>LT</p>
                <h6 className="fw-bold mb-0" style={{ fontSize: '0.85rem' }}>{totalT8lt}</h6>
              </div>
              <div className="p-1 border rounded bg-light text-center flex-grow-1">
                <p className="small text-muted mb-0" style={{ fontSize: '0.7rem' }}>STD</p>
                <h6 className="fw-bold mb-0" style={{ fontSize: '0.85rem' }}>{numberFormatter.format(totalT8std)}</h6>
              </div>
              <div className="p-1 border rounded bg-light text-center flex-grow-1">
                <p className="small text-muted mb-0" style={{ fontSize: '0.7rem' }}>PRO</p>
                <h6 className="fw-bold mb-0" style={{ fontSize: '0.85rem' }}>{numberFormatter.format(totalT8pro)}</h6>
              </div>
            </div>
            <div className="d-flex flex-wrap gap-2 justify-content-between">
              <div className="p-1 border rounded bg-light text-center flex-grow-1" title="Teacher PRO 12 months (id 7)">
                <p className="small text-muted mb-0" style={{ fontSize: '0.65rem' }}>PRO 12m</p>
                <h6 className="fw-bold mb-0" style={{ fontSize: '0.85rem' }}>{numberFormatter.format(totalTeacherPro12)}</h6>
              </div>
              <div className="p-1 border rounded bg-light text-center flex-grow-1" title="Student SUPER 12 Months (id 8)">
                <p className="small text-muted mb-0" style={{ fontSize: '0.65rem' }}>SUPER 12m</p>
                <h6 className="fw-bold mb-0" style={{ fontSize: '0.85rem' }}>{numberFormatter.format(totalStudentSuper12)}</h6>
              </div>
              <div className="p-1 border rounded bg-light text-center flex-grow-1" title="Teacher Premium AI 12 months (id 10)">
                <p className="small text-muted mb-0" style={{ fontSize: '0.65rem' }}>P. AI 12m</p>
                <h6 className="fw-bold mb-0" style={{ fontSize: '0.85rem' }}>{numberFormatter.format(totalTeacherPremiumAi12)}</h6>
              </div>
            </div>
            <div className="d-flex flex-wrap gap-2 justify-content-between">
              <div className="p-1 border rounded bg-light text-center flex-grow-1" title="Observatorio Educativo (TOMi Analytics) (id 12)">
                <p className="small text-muted mb-0" style={{ fontSize: '0.65rem' }}>Observatorio</p>
                <h6 className="fw-bold mb-0" style={{ fontSize: '0.85rem' }}>{numberFormatter.format(totalObservatorioAnalytics)}</h6>
              </div>
              <div className="p-1 border rounded bg-light text-center flex-grow-1" title="Laboratorios STEM offline (12 months) (id 13)">
                <p className="small text-muted mb-0" style={{ fontSize: '0.65rem' }}>Labs 12m</p>
                <h6 className="fw-bold mb-0" style={{ fontSize: '0.85rem' }}>{numberFormatter.format(totalStemLabsOffline12)}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* --- COLUMNA CENTRAL: Forecast by Month --- */}
    <div className="col-lg-5 d-flex flex-column">
      <div className="card shadow-sm opportunities-compact-card flex-grow-1">
        <div className="card-body py-1 px-2 h-100 d-flex flex-column">
          <PipelineAreaChart title="Forecast by Month" pipelinedata={pipelineForecastChart} />
          <ActiveWonStackedBar activeAmount={activeAmount} wonAmount={wonAmount} lostAmount={lostAmount} />
        </div>
      </div>
    </div>

    {/* --- COLUMNA DERECHA: Gráfico torta por país --- */}
    <div className="col-lg-4">
      <div className="card shadow-sm h-100 opportunities-compact-card">
        <div className="card-body d-flex flex-column py-1 px-2">
          <h6 className="card-title mb-1 text-center" style={{ fontSize: '0.9rem' }}>Opportunities by country</h6>
          <div className="flex-grow-1" style={{ minHeight: '160px' }}>
            <CountryPieChart title="Distribución por País" labels={chartLabels} dataValues={chartDataValues} />
          </div>
        </div>
      </div>
    </div>
  </div>
</>
      )}
        </div>
        <div className="d-flex gap-1 mb-2 flex-wrap ">
       
          <div className="col-lg-2 col-md-12 " >  
            <Form.Control
              placeholder="Search all columns..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className='toolbar-control'
            />
          </div> 
          <div className="col-lg-2 col-md-12">
            <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={stageOptions}
                    isLoading={stageOptions.length === 0}
                    // --- Key Change: Add isMulti prop ---
                    isMulti
                    // --- Key Change: onChange now receives an array of selected options ---
                    onChange={(selectedOptions) => {
                      // `selectedOptions` will be an array of objects: [{ value: 10, label: 'Stage 10%' }, ...]
                      // Map it to just the values to store in your state
                      const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
                      setSelectedStages(values); // Update your state with the array of selected values
                    }}
                    placeholder="Stage..."
                    // --- Key Change: value should now be an array of selected option objects ---
                    value={getStageByValue(selectedStages)}
                    components={{
                      MultiValueLabel: CustomMultiValueLabel,
                    }}
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        minWidth: 100,
                        flex: 1,
                      }),
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 9999
                      }),
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999
                      })
                    }}
                  />
          </div>

            <div className="col-lg-2 col-md-12">
            <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={statusOptions}
                    isLoading={statusOptions.length === 0}
                    isMulti
                    onChange={(selectedOptions) => {
                      const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
                      setSelectedStatus(values); // Update your state with the array of selected values
                    }}
                    placeholder="Status..."
                    // --- Key Change: value should now be an array of selected option objects ---
                    value={getStatusByValue(selectedStatus)}
                    components={{
                      MultiValueLabel: CustomMultiValueLabel,
                    }}
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        minWidth: 100,
                        flex: 1,
                      }),
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 9999
                      }),
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999
                      })
                    }}
                  />
          </div>

          {typeOptions.length > 0 && (
            <div className="col-lg-2 col-md-12">
              <Select
                className="react-select-container"
                classNamePrefix="react-select"
                options={typeOptions}
                isMulti
                onChange={(selectedOptions) => {
                  const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
                  setSelectedTypes(values);
                }}
                placeholder="Type..."
                value={getTypeByValue(selectedTypes)}
                components={{
                  MultiValueLabel: CustomMultiValueLabel,
                }}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    minWidth: 100,
                    flex: 1,
                  }),
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 9999
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999
                  })
                }}
              />
            </div>
          )}

          

          <div className="col-lg-2 col-md-12">
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={salesManOptions}
                    isLoading={salesManOptions.length === 0}
                    // --- Key Change: Add isMulti prop ---
                    isMulti
                    // --- Key Change: onChange now receives an array of selected options ---
                    onChange={(selectedOptions) => {
                      // `selectedOptions` will be an array of objects: [{ value: 10, label: 'Stage 10%' }, ...]
                      // Map it to just the values to store in your state
                      const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
                      setselectedSalesMan(values); // Update your state with the array of selected values
                    }}
                    placeholder="Created by..."
                    // --- Key Change: value should now be an array of selected option objects ---
                    value={getsalesManByValue(selectedSalesMan)}
                components={{
                      MultiValueLabel: CustomMultiValueLabel,
                    }}
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        minWidth: 100,
                        flex: 1,
                      }),
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 9999
                      }),
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999
                      })
                    }}
                  />
          </div>
          <div className="col-lg-2 col-md-12">
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={tomiOwnerOptions}
                    isLoading={tomiOwnerOptions.length === 0}
                    isMulti
                    onChange={(selectedOptions) => {
                      const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
                      setSelectedTomiOwner(values);
                    }}
                    placeholder="TOMi Owner..."
                    value={getTomiOwnerByValue(selectedTomiOwner)}
                    components={{
                      MultiValueLabel: CustomMultiValueLabel,
                    }}
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        minWidth: 100,
                        flex: 1,
                      }),
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 9999
                      }),
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999
                      })
                    }}
                  />
          </div>
          <div className="col-lg-2 col-md-12">
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={countryOptions}
                    isLoading={countryOptions.length === 0}
                    isMulti
                    onChange={(selectedOptions) => {
                      const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
                      setSelectedCountries(values);
                    }}
                    placeholder="Country..."
                    value={getCountryByValue(selectedCountries)}
                    components={{
                      MultiValueLabel: CustomMultiValueLabel,
                    }}
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        minWidth: 100,
                        flex: 1,
                      }),
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 9999
                      }),
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999
                      })
                    }}
                  />
          </div>
          {channelTierOptions.length > 0 && (
            <div className="col-lg-2 col-md-12">
              <Select
                className="react-select-container"
                classNamePrefix="react-select"
                options={channelTierOptions}
                isLoading={channelTierOptions.length === 0}
                isMulti
                onChange={(selectedOptions) => {
                  const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
                  setSelectedChannelTiers(values);
                }}
                placeholder="Channel tier..."
                value={getChannelTierByValue(selectedChannelTiers)}
                components={{
                  MultiValueLabel: CustomMultiValueLabel,
                }}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    minWidth: 100,
                    flex: 1,
                  }),
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 9999
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999
                  })
                }}
              />
            </div>
          )}
        
          <div className="position-relative col-lg-2 col-md-12" ref={datePickerRef} >
                  
                  {/* Usamos InputGroup para poder añadir el botón de limpiar */}
                  <InputGroup onClick={handleDatePickerOpen} style={{ cursor: 'pointer' }}>
                      <Form.Control
                          readOnly
                          value={
                              range[0].startDate && range[0].endDate
                              ? `${range[0].startDate.toLocaleDateString('es-ES')} - ${range[0].endDate.toLocaleDateString('es-ES')}`
                              : 'Filtrar por fecha...'
                          }
                          className='toolbar-control'
                          style={{ 
                              cursor: 'pointer',
                              // Evita que el borde derecho del input se vea raro cuando aparece el botón
                              borderTopRightRadius: range[0].startDate ? 0 : '0.375rem',
                              borderBottomRightRadius: range[0].startDate ? 0 : '0.375rem' 
                          }}
                      />

                      {/* El botón de limpiar SOLO aparece si hay una fecha seleccionada */}
                      {range[0].startDate && (
                          <Button 
                              variant="light" 
                              onClick={clearDateFilter} 
                              className="d-flex align-items-center border"
                              style={{ zIndex: 5 }} // Asegura que el botón esté por encima
                          >
                                <i className="bi bi-x-circle-fill" style={{ color: 'grey', fontSize: '1rem' }}></i>

                          </Button>
                      )}
                  </InputGroup>

                  {/* El pop-up del calendario (sin cambios aquí) */}
                  {isDatePickerOpen && (
                      <div className="position-absolute shadow-lg" style={{ zIndex: 1050, top: '100%', ...datePickerPosition }}>
                          <CustomDateRange
                              range={range}
                              handleDateChange={handleDateChange}
                              setIsDatePickerOpen={setIsDatePickerOpen}
                          />
                      </div>
                  )}
          </div>
         <h5 className="mb-2 fw-bold" style={{ fontSize: '1rem' }}>
             {recordCount}
               </h5>
        </div>


        {/* Tabla */}
        <Table hover responsive className="align-middle">
          <thead className="table-light">
            <tr>

            
                <th onClick={() => toggleSort('opportunitieName')} role="button">
                  Opportunity Name <SortIcon col="opportunitieName" />
                </th>
           
               
                <th onClick={() => toggleSort('channelname')} role="button">
                  Reseller Name <SortIcon col="channelname" />
                </th>
           
              
           
                <th onClick={() => toggleSort('closing_date')} role="button">
                  Closing Date <SortIcon col="closing_date" />
                </th>
      
           
     
                <th onClick={() => toggleSort('running_days')} role="button">
                  Age (days) <SortIcon col="running_days" />
                </th>
      
               
              <th onClick={() => toggleSort('owner_usr')} role="button">
                Created by <SortIcon col="owner_usr" />
              </th>

              {hasFullChannelView && (
                <th onClick={() => toggleSort('tomi_owner')} role="button">
                  TOMi owner <SortIcon col="tomi_owner" />
                </th>
              )}

              <th onClick={() => toggleSort('stage')} role="button">
                Stage <SortIcon col="stage" />
              </th>

        
                <th onClick={() => toggleSort('country')} role="button">
                  Country <SortIcon col="country" />
                </th>
       
              {hasFullChannelView && (
                <th onClick={() => toggleSort('moneyAmount')} role="button" style={{ textAlign: 'right' }}>
                  Amount <SortIcon col="moneyAmount" />
                </th>
              )}


              {/*parseInt(usr_type)==0 && (
                <th onClick={() => toggleSort('ROI')} role="button" style={{ textAlign: 'right' }}>
                  ROI <SortIcon col="ROI" />
                </th>

              )*/}

                <th onClick={() => toggleSort('last_activity')} role="button" style={{ textAlign: 'right' }}>
                  ACT <SortIcon col="last_activity" />
                </th>



              
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => {
              
              // 1. Calcula el ROI
              //const roi = (row.profit - row.cardCost) / row.cardCost * 100;

              // 2. Define el objeto de estilo basado en el ROI
              const cellStyle = {
                textAlign: 'right'
              };

              const getRowClassName = (status) => {
                if (status == 0) { // Por validar
                  return 'table-warning'; // Clase de Bootstrap para un fondo rojo claro
                } else if (status == 4) { // Anulada
                  return 'table-invalidated'; // Clase de Bootstrap para un fondo gris
                } else if (status == 2) { // Ganado
                  return 'table-success'; // Clase de Bootstrap para un fondo verde claro
                } else if (status == 3) { // Perdida
                   return 'table-lost'; // Clase de Bootstrap para un fondo amarillo/naranja claro
                }//1 es activo
                return ''; // Sin clase adicional
                };

              return(
              <tr key={row.id} onClick={() => { if (row.id != null) navigate({ pathname: '/opportunitypage', search: `?id=${encodeURIComponent(row.id)}` }); }} className={getRowClassName(parseInt(row.current_status))}>

               <td>
                 {row.id != null ? (
                   <Link to={`/opportunitypage?id=${encodeURIComponent(row.id)}`} onClick={(e) => e.stopPropagation()} className="text-decoration-none text-dark">{row.opportunitieName}</Link>
                 ) : (
                   row.opportunitieName
                 )}
               </td>
               <td>{row.channelname}</td>
                <td className="editable-closing-date" onClick={(e) => e.stopPropagation()}>
                  {editingClosingDateId === row.id ? (
                    <span onClick={(e) => e.stopPropagation()} className="d-flex align-items-center gap-1 flex-nowrap">
                      <Form.Control
                        type="date"
                        size="sm"
                        className="editable-closing-date-input"
                        value={editingClosingDateValue}
                        onChange={(e) => setEditingClosingDateValue(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            saveClosingDate(row, editingClosingDateValue);
                          } else if (e.key === 'Escape') {
                            cancelEditClosingDate();
                          }
                        }}
                        autoFocus
                      />
                      <i
                        className="bi bi-check-lg text-success editable-closing-date-icon"
                        onClick={(e) => { e.stopPropagation(); saveClosingDate(row, editingClosingDateValue); }}
                        title="Guardar"
                        role="button"
                        aria-label="Guardar"
                      />
                    </span>
                  ) : (
                    <span onClick={(e) => e.stopPropagation()} className="d-flex align-items-center gap-1 flex-nowrap">
                      <span>{row.closing_date || '—'}</span>
                      <i
                        className="bi bi-pencil editable-closing-date-icon"
                        onClick={(e) => startEditClosingDate(e, row)}
                        title="Editar fecha"
                        role="button"
                        aria-label="Editar fecha"
                      />
                    </span>
                  )}
                </td>
               <td>{getDaysDifferenceIgnoringTime(row.created_at)}</td>
                <td>{row.owner_usr}</td>
                {hasFullChannelView && (
                    <td>{row.internal_owner_name}</td>
                )}
              <td>{row.stage}</td>
               <td>{row.country}</td>
                {hasFullChannelView && <td  style={{ textAlign: 'right' }}>{currencyFormatter.format( row.moneyAmount)}</td>}
                {/*parseInt(usr_type) === 0 && (
                  <td style={cellStyle}>
                    {roi.toFixed(1)}%
                  </td>
                )*/}
                 <td style={cellStyle}>
                    {row.last_activity}
                  </td>
              </tr>
            )})}
            {rows.length === 0 && (
              <tr>
                <td colSpan="10" className="text-center py-4">
                  No results
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        {(parseInt(usr_type) === 0 || Boolean(channel_id)) && (
          <div className="floating-action-button">
            <Button
              variant="primary"
              className="floating-action-button__btn"
              onClick={() => setModalOpen(true)}
              aria-label="Crear nueva oportunidad"
              type="button"
            >
              +
            </Button>
          </div>
        )}
      </div>
    );
};

export default Opportunities;
